import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { QrCode2, EventNote } from '@mui/icons-material';
import StudentQRPass from './StudentQRPass';
import StudentBookings from './StudentBookings';
import PillTabs from '../../components/shared/PillTabs';
import PageShell from '../../components/shared/PageShell';

const TABS = [
  { key: 'pass', label: 'Digital Pass', icon: <QrCode2 /> },
  { key: 'bookings', label: 'My Bookings', icon: <EventNote /> },
];

/**
 * StudentAccess — thin shell that hosts the Digital Pass and Bookings tabs.
 * Uses shared PillTabs. The sticky top offset has been removed.
 */
function StudentAccess({ showSnackbar }) {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    location.state?.tab === 'bookings' ? 'bookings' : 'pass'
  );

  useEffect(() => {
    if (location.state?.tab === 'bookings') {
      setActiveTab('bookings');
    }
  }, [location.state]);

  return (
    <PageShell title="Access" maxWidth="sm">
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <PillTabs
          tabs={TABS}
          value={activeTab}
          onChange={setActiveTab}
          fullWidth
        />
      </Box>
      <Box>
        {activeTab === 'pass' && <StudentQRPass showSnackbar={showSnackbar} />}
        {activeTab === 'bookings' && (
          <StudentBookings
            showSnackbar={showSnackbar}
            initialFilter={location.state?.bookingsFilter}
          />
        )}
      </Box>
    </PageShell>
  );
}

export default StudentAccess;
